module.exports = new __parcel__URL__("smile.43d71d81.svg").toString();